import { useState } from "react";
import { MPAddContainerForm } from "./form";
import { useNavigate } from "react-router-dom";
import { useGetContainersQuery } from "../../services";

export const AddCustomPluginContainer = () => {
  const [showForm, setShowForm] = useState(true);
  const navigate = useNavigate();

  //const { data: newContainers } = useGetContainersQuery();

  const handleClose = () => {
    setShowForm(false);
    navigate("/management_portal/dashboard");
  };

  return <>{showForm && <MPAddContainerForm onClose={handleClose} />}</>;
};
